import React from 'react'
import { useSelector } from 'react-redux'

export const GlobalLoader = () => {

  const { globalLoader } = useSelector(state => state.ui);
  
  if( !globalLoader ) return null;

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  )
}
